import React from "react"
import Navbar from "../../../Common/Components/Navbar"
import Footer from "../../../Common/Components/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import AddActTransComp from "./Component/AddActTransComp"


const AddActTrans =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <AddActTransComp />
        </div>
        <Footer />
        </>
    )
}

export default AddActTrans